/**
 * FAB Grammar AST — per E-023 §B.
 *
 * The FAB parser produces a discriminated-union AST. Six node kinds total:
 *
 *   - fuzzy:     a bareword that should match via Levenshtein/prefix
 *   - phrase:    a "double-quoted exact phrase"
 *   - predicate: field:value (e.g., book:cleic, acct:1100, type:"sales order")
 *   - not:       -x or NOT x
 *   - and:       implicit (adjacency) or explicit AND
 *   - or:        explicit OR
 *
 * The parser is **forgiving by design** — unclosed quotes, mismatched parens,
 * and trailing operators do not throw. They produce a partial AST plus an
 * entry in `errors[]`. The user keeps typing; the bar keeps responding.
 *
 * Inherits: E-023 (FAB Method), E-013 (Canon Innovation Filter — Timeless
 * pattern, Agnostic mathematics, Divine forgiveness).
 */
/**
 * Reserved fields registered ecosystem-wide per E-023.
 *
 * App-specific fields (e.g., `account_type:`, `currency:`) MAY also be used —
 * the parser does not gate on the field allowlist; it merely lowercases the
 * field name and packages it for the source's `query()` to interpret.
 *
 * Reserved fields are surfaced separately so the ranker can apply
 * cross-source semantics (e.g., `book:` filters every source by tenant,
 * regardless of which source returned the hit).
 */
export const RESERVED_FIELDS = [
    "app",
    "book",
    "type",
    "acct",
    "from",
    "to",
    "tag",
    "vis",
];
/** Empty-AND singleton — used as the AST when input is empty or all whitespace. */
export const EMPTY_AND = { kind: "and", children: [] };
//# sourceMappingURL=ast.js.map